import './ui.css';

/**
 * Estado vacío genérico para listas sin datos (o mientras cargan).
 *
 * @param {{ icon?: React.ReactNode, title: string, description?: string }} props
 */
export default function EmptyState({ icon, title, description }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state__icon">{icon}</div>}
      <p className="empty-state__title">{title}</p>
      {description && <p className="empty-state__description">{description}</p>}
    </div>
  );
}
